var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 18,
    height: 19,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.094 0.374984L5.875 4.39898L2.656 0.374984C2.39 0.0429837 1.943 -0.0840164 1.544 0.0559836C1.144 0.196984 0.875 0.574984 0.875 0.999984V16C0.875 17.103 1.772 18 2.875 18H16.875C17.978 18 18.875 17.103 18.875 16V0.999984C18.875 0.574984 18.606 0.196984 18.206 0.0559836C17.806 -0.0820163 17.36 0.0439837 17.094 0.374984L13.875 4.39898L10.656 0.374984C10.275 -0.0990163 9.475 -0.0990163 9.094 0.374984ZM2.875 16V14H16.876V16H2.875ZM13.094 6.62498C13.475 7.09998 14.276 7.09998 14.657 6.62498L16.875 3.85098L16.876 12H2.875V3.85098L5.094 6.62498C5.475 7.09998 6.276 7.09998 6.657 6.62498L9.875 2.60098L13.094 6.62498Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.df1c4c6f.svg";
export { ForwardRef as ReactComponent };